module.exports = __webpack_public_path__ + "media/images/guides/random-08-cfcd2eb6f733dbb74e8b95dc24761772.svg";